import { render } from "./itemsmovement.vue?vue&type=template&id=e2220aec"
import script from "./itemsmovement.vue?vue&type=script&lang=js"
export * from "./itemsmovement.vue?vue&type=script&lang=js"

import "./itemsmovement.vue?vue&type=style&index=0&id=e2220aec&lang=css"

import exportComponent from "/Users/arthaskyline/Documents/FILE_DELFIN/kodingan-arthaskyline/level-up/levelup-github/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__